import { portalWalkthrough as portalWalkthroughActions } from "../../constants/actionTypes";

const INITIAL_STATE = {
  key: new Date(),
  run: false,
  continuous: true,
  loading: false,
  stepIndex: 0,
  steps: "",
};

const portalWalkthrough = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case portalWalkthroughActions.SET_STEPS:
      return {
        ...state,
        steps: action?.payload,
      };
    case portalWalkthroughActions.START:
      return { ...state, run: true };
    case portalWalkthroughActions.RESET:
      return { ...state, stepIndex: 0 };
    case portalWalkthroughActions.STOP:
      return { ...state, run: false };
    case portalWalkthroughActions.NEXT_OR_PREV:
      return { ...state, stepIndex: action?.payload };
    case portalWalkthroughActions.RESTART:
      return {
        ...state,
        stepIndex: 0,
        run: true,
        loading: false,
        key: new Date(),
      };
    
    default:
      return state;
  }
};

export default portalWalkthrough;
